import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './authSlice';
import uploadReducer from './uploadSlice';
import userReducer from './userSlice';
import { uploadApi } from '../services/api';

const persistIgnoredActions = [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER];

const authPersistConfig = {
  key: 'webim-auth',
  version: 1,
  storage,
};

const userPersistConfig = {
  key: 'webim-user',
  version: 1,
  storage,
};

const isTestEnv = process.env.NODE_ENV === 'test';

const authReducerWithPersist = isTestEnv
  ? authReducer
  : persistReducer(authPersistConfig, authReducer);

const userReducerWithPersist = isTestEnv
  ? userReducer
  : persistReducer(userPersistConfig, userReducer);

const rootReducer = combineReducers({
  auth: authReducerWithPersist,
  upload: uploadReducer,
  user: userReducerWithPersist,
  [uploadApi.reducerPath]: uploadApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: persistIgnoredActions,
      },
    }).concat(uploadApi.middleware),
});

setupListeners(store.dispatch);

/** Null in tests (no async rehydrate). */
export const persistor = isTestEnv ? null : persistStore(store);
